import { useMutation } from 'react-query';
import api from 'api';
export const useBiometricAuthenticate = () => {
  return useMutation(({
    trustedDeviceReferenceId,
    credential
  }) => api.hades.postBiometricAuthenticate({
    trustedDeviceReferenceId,
    credential
  }), {
    useErrorBoundary: false
  });
};